<div class="container-fluid">
  <app-page-title title="Mes contacts"></app-page-title>
  <p class="text-white text-center m-3">Vos contacts se remplissent automatiquement en fonction des personnes avec
    lesquelles
    vous partagez des données.</p>
  <div>
    <ng-container *ngIf="dataSource && dataSource.data.length > 0; else noContact">
      <div class="d-flex align-items-center">
        <mat-form-field>
          <mat-icon matPrefix color="primary">search</mat-icon>
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
        </mat-form-field>
      </div>
      <div>
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
            <td mat-cell *matCellDef="let row" class="main">{{ row.name }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let row"><a href="mailto:{{ row.email }}">{{ row.email }}</a></td>
          </ng-container>
          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Téléphone</th>
            <td mat-cell *matCellDef="let row"><a href="tel:{{ row.phoneNumber }}">{{ row.phoneNumber }}</a></td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let row">{{ row.type }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <button class="mobile-inline" mat-icon-button (click)="confirmDelete(row.user)">
                <mat-icon color="primary">delete_forever</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
          showFirstLastButtons></mat-paginator>
      </div>
    </ng-container>
    <ng-template #noContact>
      <span class="no-content">Aucun contact n'est encore enregistré</span>
    </ng-template>
  </div>

</div>